import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';

import { ModalBaseModule } from 'Angular/features/components/modals/modal-base/modal-base.module';
import { DisabledModule } from 'Angular/features/directives/disabled/disabled.module';
import { IconModule } from 'Angular/features/directives/icon/icon.module';
import { NgModelChangeDebouncedModule } from 'Angular/features/directives/ng-model-change-debounced/ng-model-change-debounced.module';

import { InviteFriendModalComponent } from './invite-friend-modal.component';

@NgModule({
    imports: [CommonModule, DisabledModule, FormsModule, ModalBaseModule, NgModelChangeDebouncedModule, IconModule],
    declarations: [InviteFriendModalComponent],
    exports: [InviteFriendModalComponent],
})
export class InviteFriendModalModule {}
